export default __webpack_public_path__ + "static/media/critical_unusual_incident.d8be14a3.png";